import { motion } from 'framer-motion'
import React from 'react'

const Slider = ({ count, index, onChange }) => (
  <div className="flex items-center mb-8 space-x-2">
    {Array.from({ length: count }).map((_, i) => (
      <motion.button
        key={i}
        onClick={() => onChange(i)}
        type="button"
        aria-label={`Reference ${i + 1}`}
        className={`border-2 border-black rounded-full h-2.5 transition-all hover:bg-white hover:shadow-tpmp hover:border-white ${
          i === index && 'bg-black'
        }`}
        animate={{ width: i === index ? 40 : 10 }}
      ></motion.button>
    ))}
  </div>
)

export default Slider
